export default __webpack_public_path__ + "static/media/ray.kickz-avatar.adff9ace.png";